// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MindmapEditor{
    height: 100%;
    padding: 10px;
    background: #f9f9f6;
}

.MindmapEditor--fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    padding: 0;
    background: #f9f9f6;
}

.MindmapEditor--fullscreen .MindmapEditor_wrapper {
    border-radius: 0;
    border: none;
}

.MindmapEditor--fullscreen .MindmapEditor_zoom_controls {
    position: fixed;
    bottom: 20px;
    right: 20px;
}

.MindmapEditor_wrapper{
    background: #FFFFFF;
    border: 1px solid #E2E9FC;
    border-radius: 24px;
    overflow: hidden;

    display: flex;
    height: 100%;
    min-height: 400px;
}

.MindmapEditor_tools{
    border-right: 1px solid #E2E9FC;
    width: 200px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.MindmapEditor_tools_header{
    padding: 18px 23px;
    border-bottom: 1px solid #E2E9FC;

    display: flex;
    align-items: center;
    justify-content: center;
}

.MindmapEditor_tools_header_title{
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
}


.MindmapEditor_tools_categories{
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.MindmapEditor_tools_categories::-webkit-scrollbar{
    display: none;
}

.MindmapEditor_settings{
    border-top: 1px solid #E2E9FC;
    padding: 12px 16px;
    flex-shrink: 0;
}

.MindmapEditor_settings_title{
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
}

.MindmapEditor_settings_row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.MindmapEditor_settings_label{
    font-size: 12px;
    color: #666;
}

.MindmapEditor_bg_switcher {
    position: relative;
    display: flex;
    background: linear-gradient(135deg, #f5f5f5 0%, #eaeaea 100%);
    border-radius: 6px;
    padding: 2px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
}

.MindmapEditor_bg_switcher_slider {
    position: absolute;
    top: 2px;
    left: 2px;
    width: calc(50% - 2px);
    height: calc(100% - 4px);
    background: linear-gradient(135deg, #ff9500 0%, #ff7b00 100%);
    border-radius: 4px;
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 3px rgba(255, 149, 0, 0.3);
    z-index: 0;
}

.MindmapEditor_bg_switcher_btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 500;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: #666;
    cursor: pointer;
    transition: color 0.2s ease;
    z-index: 1;
    position: relative;
}

.MindmapEditor_bg_switcher_btn.active {
    color: #fff;
}

.MindmapEditor_color_picker_wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 12px;
    margin-bottom: 0;
}

.MindmapEditor_color_picker_wrapper.visible {
    max-height: 60px;
    opacity: 1;
    padding: 10px 12px;
    margin-bottom: 12px;
}

.MindmapEditor_settings_color_enhanced {
    width: 0;
    height: 0;
    opacity: 0;
    position: absolute;
}

.MindmapEditor_color_preview {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    position: relative;
}

.MindmapEditor_color_preview:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.MindmapEditor_color_preview:active {
    transform: scale(0.95);
}

.MindmapEditor_color_hex {
    font-size: 11px;
    font-weight: 600;
    color: #888;
    font-family: 'Monaco', 'Menlo', monospace;
    letter-spacing: 0.5px;
}

.MindmapEditor_color_label {
    display: block;
    position: relative;
    cursor: pointer;
}

.MindmapEditor_settings_bg_selector {
    display: flex;
    gap: 4px;
}

.MindmapEditor_settings_bg_btn {
    padding: 4px 8px;
    font-size: 11px;
    border: 1px solid #E2E9FC;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    color: #666;
    transition: all 0.15s ease;
}

.MindmapEditor_settings_bg_btn:hover {
    background: #f5f5f5;
}

.MindmapEditor_settings_bg_btn.active {
    background: #f90;
    border-color: #f90;
    color: #fff;
}

.MindmapEditor_settings_color{
    width: 32px;
    height: 24px;
    border: 1px solid #E2E9FC;
    border-radius: 4px;
    cursor: pointer;
    padding: 0;
    background: transparent;
}

.MindmapEditor_settings_color::-webkit-color-swatch-wrapper{
    padding: 2px;
}

.MindmapEditor_settings_color::-webkit-color-swatch{
    border: none;
    border-radius: 2px;
}

.MindmapEditor_settings_toggle{
    position: relative;
    width: 36px;
    height: 20px;
    cursor: pointer;
}

.MindmapEditor_settings_toggle input{
    opacity: 0;
    width: 0;
    height: 0;
}

.MindmapEditor_settings_toggle_slider{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 20px;
    transition: 0.3s;
}

.MindmapEditor_settings_toggle_slider::before{
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
}

.MindmapEditor_settings_toggle input:checked + .MindmapEditor_settings_toggle_slider{
    background-color: #f90;
}

.MindmapEditor_settings_toggle input:checked + .MindmapEditor_settings_toggle_slider::before{
    transform: translateX(16px);
}

.MindmapEditor_right{
    width: 100%;
}

.MindmapEditor_right_header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E2E9FC;
    padding: 8px;
}

.MindmapEditor_right_header_title{
    display: flex;
    justify-content: center;
    flex-grow: 1;
}

.MindmapEditor_workspace{
    position: relative;
    width: 100%;
    height: 100%;
    user-select: none;
    overflow: hidden;

    background-size: 10px 10px;
    background-position: -5px -5px;
    background-color: #fff5ec;
    background-image: radial-gradient(#999 0%, #999 9%, transparent 12%);
    outline: none;
}

.MindmapEditor_object{
    position: absolute;
    background-color: #fc0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f90;
    z-index: 5;
    cursor: grab;
   /* transform-origin: left top;*/
}


.MindmapEditor_object--box{

}

.MindmapEditor_object--round{
    border-radius: 100%;
}

.MindmapEditor_object--triangle,
.MindmapEditor_object--trapezoid,
.MindmapEditor_object--star {
    border: none;
    background: transparent;
}

.MindmapEditor_object_svg {
    pointer-events: none;
}

.MindmapEditor_object--sticker{
    background: linear-gradient(135deg, #fffacd 0%, #fff59d 100%);
    border: none;
    border-radius: 2px;
    box-shadow: 2px 3px 8px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1);
    min-height: 80px;
}

.MindmapEditor_object--sticker::before{
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 14px;
    height: 14px;
    background: radial-gradient(circle at 30% 30%, #ff6b6b, #c92a2a);
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 -1px 2px rgba(0,0,0,0.2);
    z-index: 10;
}

.MindmapEditor_object--sticker::after{
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.1) 100%);
    border-radius: 0 0 2px 0;
}

.MindmapEditor_object--sticker .MindmapEditor_object_text{
    padding-top: 28px;
    padding-bottom: 8px;
}

.MindmapEditor_object--sticker .MindmapEditor_object_marker_lt,
.MindmapEditor_object--sticker .MindmapEditor_object_marker_rt,
.MindmapEditor_object--sticker .MindmapEditor_object_marker_lb,
.MindmapEditor_object--sticker .MindmapEditor_object_marker_rb,
.MindmapEditor_object--sticker .MindmapEditor_object_marker_rotate{
    display: none;
}

.MindmapEditor_object--sticker.MindmapEditor_object--selected,
.MindmapEditor_object--sticker.MindmapEditor_object--multi-selected{
    outline: 2px solid #0af;
    outline-offset: 0px;
}

.MindmapEditor_object--text{
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MindmapEditor_object--text .MindmapEditor_object_text{
    font-size: 16px;
    color: #333;
    text-align: center;
    padding: 4px 8px;
}

.MindmapEditor_object--text.MindmapEditor_object--selected,
.MindmapEditor_object--text.MindmapEditor_object--multi-selected{
    outline: 1px dashed #0af;
    outline-offset: 2px;
}

.MindmapEditor_toolsCollapser_head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
}

.MindmapEditor_toolsCollapser_head_title{

}

.MindmapEditor_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
    margin-left: auto;
    margin-right: 8px;
}

.MindmapEditor_filter_icon:hover {
    opacity: 1;
}

.MindmapEditor_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.MindmapEditor_filter_icon--active:hover {
    opacity: 1;
}

.MindmapEditor_toolsCollapser_head_arrow{
    flex-shrink: 0;
    font-size: 0;
    width: 9px;
    height: 9px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.MindmapEditor_toolsCollapser_collapser{
    padding: 0px 10px;
    background-color: #f6f6f9;
}

.MindmapEditor_toolsCollapser_items{
    padding: 10px 0px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.MindmapEditor_tool{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f30;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
    font-size: 10px;
}

.MindmapEditor_tool--box{
    background-color: #fc0;
    border: 1px solid #f90;
    width: 42px;
    height: 42px;
}

.MindmapEditor_tool--round{
    background-color: #fc0;
    border: 1px solid #f90;
    width: 42px;
    height: 42px;
    border-radius: 100%;
}

.MindmapEditor_tool--triangle{
    width: 42px;
    height: 42px;
    position: relative;
}

.MindmapEditor_tool--triangle::after{
    content: '';
    position: absolute;
    inset: 0;
    background-color: #f90;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    z-index: 0;
}

.MindmapEditor_tool--triangle::before{
    content: '';
    position: absolute;
    inset: 2px;
    background-color: #fc0;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    z-index: 1;
}

.MindmapEditor_tool--trapezoid{
    width: 42px;
    height: 42px;
    position: relative;
}

.MindmapEditor_tool--trapezoid::after{
    content: '';
    position: absolute;
    inset: 0;
    background-color: #f90;
    clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
    z-index: 0;
}

.MindmapEditor_tool--trapezoid::before{
    content: '';
    position: absolute;
    inset: 2px;
    background-color: #fc0;
    clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
    z-index: 1;
}

.MindmapEditor_tool--star{
    width: 42px;
    height: 42px;
    position: relative;
}

.MindmapEditor_tool--star::after{
    content: '';
    position: absolute;
    inset: 0;
    background-color: #f90;
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    z-index: 0;
}

.MindmapEditor_tool--star::before{
    content: '';
    position: absolute;
    inset: 2px;
    background-color: #fc0;
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    z-index: 1;
}

.MindmapEditor_tool--sticker{
    width: 36px;
    height: 42px;
    position: relative;
    background: linear-gradient(135deg, #fffacd 0%, #fff59d 100%);
    border-radius: 2px;
    box-shadow: 1px 2px 4px rgba(0,0,0,0.15);
}

.MindmapEditor_tool--sticker::before{
    content: '';
    position: absolute;
    top: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 8px;
    height: 8px;
    background: radial-gradient(circle at 30% 30%, #ff6b6b, #c92a2a);
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0,0,0,0.3);
    z-index: 1;
}

.MindmapEditor_tool--sticker::after{
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 10px;
    height: 10px;
    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.08) 50%);
}

.MindmapEditor_tool--text{
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    cursor: pointer;
}

.MindmapEditor_tool--text:hover{
    border-color: #f90;
    background: #fffaf5;
}

.MindmapEditor_tool_text_preview{
    font-size: 16px;
    font-weight: 500;
    color: #666;
}

.MindmapEditor_object--selected{
    box-shadow: 0 0 0 2px #0af;
}

.MindmapEditor_object--multi-selected{
    box-shadow: 0 0 0 2px #0af;
}

.MindmapEditor_selection_box {
    position: absolute;
    border: 1px dashed #0af;
    background: rgba(0, 170, 255, 0.1);
    pointer-events: none;
    z-index: 1000;
}

.MindmapEditor_style_popup {
    position: absolute;
    transform: translateX(-50%);
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.15);
    padding: 8px 12px;
    z-index: 1001;
    display: flex;
    gap: 16px;
    align-items: center;
}

.MindmapEditor_style_popup_section {
    display: flex;
    align-items: center;
    gap: 8px;
}

.MindmapEditor_style_popup_label {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
}

.MindmapEditor_style_popup_colors {
    display: flex;
    gap: 4px;
    align-items: center;
}

.MindmapEditor_style_popup_color {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: transform 0.1s, border-color 0.1s;
}

.MindmapEditor_style_popup_color:hover {
    transform: scale(1.1);
}

.MindmapEditor_style_popup_color--active {
    border-color: #333;
}

.MindmapEditor_style_popup_picker {
    width: 24px;
    height: 24px;
    border: none;
    padding: 0;
    cursor: pointer;
    background: none;
    border-radius: 4px;
}

.MindmapEditor_style_popup_picker::-webkit-color-swatch-wrapper {
    padding: 0;
}

.MindmapEditor_style_popup_picker::-webkit-color-swatch {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.MindmapEditor_style_popup_border {
    display: flex;
    gap: 6px;
    align-items: center;
}

.MindmapEditor_style_popup_select {
    padding: 4px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 12px;
    background: white;
    cursor: pointer;
}

.MindmapEditor_object_markers{
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
}

.MindmapEditor_object_marker{
    position: absolute;
    width: 10px;
    height: 10px;
    pointer-events: all;

    background-color: #999;
}

.MindmapEditor_object_marker_lt{
    right: 100%;
    bottom: 100%;
    cursor: nwse-resize;
}
.MindmapEditor_object_marker_lb{
    right: 100%;
    top: 100%;
    cursor: nesw-resize;
}
.MindmapEditor_object_marker_rt{
    left: 100%;
    bottom: 100%;
    cursor: nesw-resize;
}
.MindmapEditor_object_marker_rb{
    left: 100%;
    top: 100%;
    cursor: nwse-resize;
}
.MindmapEditor_object_marker_rotate{
    border-radius: 100%;
    left: calc(50% - 5px);
    bottom: 100%;
    cursor: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 12 12, grab;
}

.MindmapEditor_object_content {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.MindmapEditor_object_content--star {
    padding: 18% 12%;
}

.MindmapEditor_object_text {
    width: 100%;
    max-height: 100%;
    border: none;
    background: transparent;
    text-align: center;
    font-size: 12px;
    padding: 4px;
    position: relative;
    z-index: 2;
    outline: none;
    cursor: text;
    overflow: hidden;
    word-wrap: break-word;
    white-space: pre-wrap;
    direction: ltr;
    unicode-bidi: plaintext;
}

.MindmapEditor_object_text:empty {
    display: flex;
    justify-content: center;
    align-items: center;
}

.MindmapEditor_object_text:empty::before {
    content: '...';
    color: rgba(0, 0, 0, 0.4);
    pointer-events: none;
}

.MindmapEditor_object_text--dragging {
    cursor: grabbing;
    pointer-events: none;
    user-select: none;
}

.MindmapEditor_object_text--inactive {
    pointer-events: none;
    cursor: grab;
}

.MindmapEditor_object_text[data-placeholder]:empty::before {
    content: attr(data-placeholder);
    color: #aaa;
    font-style: italic;
    pointer-events: none;
}

.MindmapEditor_object:active {
    cursor: grabbing;
}

.MindmapEditor_right_header_title_input {
    flex-grow: 1;
    text-align: center;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    background: transparent;
}

.MindmapEditor_saving {
    color: #999;
    font-size: 12px;
    margin-right: 8px;
}

.MindmapEditor_tools_actions {
    padding: 10px;
    border-top: 1px solid #E2E9FC;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.MindmapEditor_export_btn {
    width: 100%;
    padding: 8px 16px;
    background: #4a90d9;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
}

.MindmapEditor_export_btn:hover {
    background: #3a7bc8;
}

.MindmapEditor_delete_btn {
    width: 100%;
    padding: 8px 16px;
    background: #ff4444;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
}

.MindmapEditor_delete_btn:hover {
    background: #cc0000;
}

.MindmapEditor_contextMenu {
    position: fixed;
    background: white;
    border: 1px solid #E2E9FC;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    z-index: 1010;
    min-width: 120px;
    padding: 4px 0;
}

.MindmapEditor_contextMenu_item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
}

.MindmapEditor_contextMenu_item:hover {
    background: #f5f5f5;
}

.MindmapEditor_manual_hint {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e4e4e9;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 11px;
    color: #666;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
    pointer-events: none;
}

.MindmapEditor_manual_hint div {
    white-space: nowrap;
}

.MindmapEditor_manual_hint div + div {
    margin-top: 2px;
}

.MindmapEditor_tool--arrow-thin,
.MindmapEditor_tool--arrow-thick,
.MindmapEditor_tool--arrow-hollow,
.MindmapEditor_tool--arrow-block {
    width: 42px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    cursor: pointer;
}

.MindmapEditor_tool--arrow-thin:hover,
.MindmapEditor_tool--arrow-thick:hover,
.MindmapEditor_tool--arrow-hollow:hover,
.MindmapEditor_tool--arrow-block:hover {
    border-color: #f90;
}

.MindmapEditor_tool--active {
    border-color: #f90;
    background: #fff5e6;
    box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.3);
}

.MindmapEditor_arrow_hint {
    padding: 8px 10px;
    font-size: 11px;
    color: #666;
    background: #fff5e6;
    border-radius: 4px;
    margin-bottom: 10px;
}

.MindmapEditor_arrows_section_label {
    font-size: 11px;
    color: #888;
    padding: 4px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.MindmapEditor_arrows_section_divider {
    height: 1px;
    background: #e4e4e9;
    margin: 8px 0;
}

.MindmapEditor_arrows_layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
    overflow: visible;
}

.MindmapEditor_arrow {
    pointer-events: stroke;
    cursor: pointer;
}

.MindmapEditor_arrow:hover path {
    stroke: #ff6600;
}

.MindmapEditor_snap_points {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.MindmapEditor_snap_point {
    position: absolute;
    width: 12px;
    height: 12px;
    background: #fff;
    border: 2px solid #f90;
    border-radius: 50%;
    pointer-events: auto;
    cursor: crosshair;
    z-index: 10;
    transition: transform 0.1s, background 0.1s;
}

.MindmapEditor_snap_point:hover {
    transform: scale(1.3);
    background: #f90;
}

.MindmapEditor_snap_point--active {
    background: #f90;
    transform: scale(1.3);
}

.MindmapEditor_snap_point--dim {
    opacity: 0.5;
    transform: scale(0.8);
}

.MindmapEditor_snap_point--dim:hover {
    opacity: 1;
    transform: scale(1.3);
}

.MindmapEditor_snap_point--editing {
    border-color: #0af;
}

.MindmapEditor_snap_point--editing:hover {
    background: #0af;
}

.MindmapEditor_arrow_endpoint {
    position: absolute;
    width: 14px;
    height: 14px;
    background: #0af;
    border: 2px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    z-index: 15;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    transition: transform 0.1s;
}

.MindmapEditor_arrow_endpoint:hover {
    transform: translate(-50%, -50%) scale(1.2);
}

.MindmapEditor_arrow_endpoint--start {
    background: #0af;
}

.MindmapEditor_arrow_endpoint--end {
    background: #0af;
}

.MindmapEditor_segment_handle {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #f90;
    border: 2px solid #fff;
    border-radius: 2px;
    cursor: move;
    z-index: 14;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    transition: transform 0.1s, background 0.1s;
}

.MindmapEditor_segment_handle:hover {
    transform: translate(-50%, -50%) scale(1.2);
    background: #0af;
}

.MindmapEditor_waypoint_handle {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #0af;
    border: 2px solid #fff;
    border-radius: 50%;
    cursor: move;
    z-index: 15;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    transition: transform 0.1s, background 0.1s;
}

.MindmapEditor_waypoint_handle:hover {
    transform: translate(-50%, -50%) scale(1.3);
    background: #f90;
}

.MindmapEditor_canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
}

.MindmapEditor_camera {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.MindmapEditor_camera > * {
    pointer-events: auto;
}

.MindmapEditor_zoom_controls {
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e4e4e9;
    border-radius: 8px;
    padding: 6px 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 100;
}

.MindmapEditor_zoom_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
    transition: background 0.15s, color 0.15s;
}

.MindmapEditor_zoom_btn:hover {
    background: #f0f0f0;
    color: #333;
}

.MindmapEditor_zoom_btn svg {
    color: #666;
}

.MindmapEditor_zoom_btn:hover svg {
    color: #f90;
}

.MindmapEditor_zoom_indicator {
    font-size: 12px;
    font-weight: 500;
    color: #333;
    min-width: 40px;
    text-align: center;
}

/* Folders section in toolbar */
.MindmapEditor_folders_filter {
    padding: 8px 12px;
}

.MindmapEditor_folders_filter_label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
}

.MindmapEditor_folders_filter_label input[type="checkbox"] {
    cursor: pointer;
}

.MindmapEditor_folders_list {
    max-height: 200px;
    overflow-y: auto;
    padding: 4px 8px;
}

.MindmapEditor_folders_loading {
    display: flex;
    justify-content: center;
    padding: 16px;
}

.MindmapEditor_folders_empty {
    text-align: center;
    padding: 16px;
    font-size: 12px;
    color: #999;
}

.MindmapEditor_folder_item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: grab;
    transition: background 0.15s;
}

.MindmapEditor_folder_item:hover {
    background: #f5f5f5;
}

.MindmapEditor_folder_item_icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

.MindmapEditor_folder_item_name {
    font-size: 12px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Folder block on canvas */
.MindmapEditor_object--folder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%);
    border: 2px solid #ffa000;
    border-radius: 8px;
    cursor: pointer;
    padding: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.MindmapEditor_object--folder:hover {
    box-shadow: 0 4px 12px rgba(255,160,0,0.3);
    border-color: #ff8f00;
}

.MindmapEditor_object--folder .MindmapEditor_folder_block_icon {
    width: 40px;
    height: 40px;
}

.MindmapEditor_object--folder .MindmapEditor_folder_block_name {
    font-size: 11px;
    color: #333;
    text-align: center;
    word-break: break-word;
    max-width: 100%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

/* Hide resize markers for folder blocks */
.MindmapEditor_object--folder .MindmapEditor_object_markers {
    display: none;
}

.MindmapEditor_folder_block_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.MindmapEditor_folders_breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-bottom: 1px solid #eee;
}

.MindmapEditor_folders_back_btn {
    background: none;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 12px;
    color: #666;
}

.MindmapEditor_folders_back_btn:hover {
    background: #f5f5f5;
    color: #333;
}

.MindmapEditor_folders_current_name {
    font-size: 12px;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.MindmapEditor_folder_item {
    position: relative;
}

.MindmapEditor_folder_expand_btn {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #999;
    padding: 4px 8px;
    border-radius: 4px;
}

.MindmapEditor_folder_expand_btn:hover {
    background: #f0f0f0;
    color: #666;
}

/* Notes section */
.MindmapEditor_notes_list {
    max-height: 200px;
    overflow-y: auto;
    padding: 4px 8px;
}

.MindmapEditor_notes_loading {
    display: flex;
    justify-content: center;
    padding: 16px;
}

.MindmapEditor_notes_empty {
    text-align: center;
    padding: 16px;
    font-size: 12px;
    color: #999;
}

.MindmapEditor_note_item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: grab;
    transition: background 0.15s;
    background: #fffacd;
    border: 1px solid #f0e68c;
    margin-bottom: 4px;
}

.MindmapEditor_note_item:hover {
    background: #fff8b4;
    border-color: #daa520;
}

.MindmapEditor_note_item_title {
    font-size: 12px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Tasks section */
.MindmapEditor_tasks_filter {
    padding: 8px;
    border-bottom: 1px solid #eee;
}

.MindmapEditor_tasks_filter_label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
}

.MindmapEditor_tasks_list {
    max-height: 200px;
    overflow-y: auto;
    padding: 4px 8px;
}

.MindmapEditor_tasks_loading {
    display: flex;
    justify-content: center;
    padding: 16px;
}

.MindmapEditor_tasks_empty {
    text-align: center;
    padding: 16px;
    font-size: 12px;
    color: #999;
}

.MindmapEditor_task_item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: grab;
    transition: background 0.15s;
    background: #fff;
    border: 1px solid #ddd;
    margin-bottom: 4px;
}

.MindmapEditor_task_item:hover {
    background: #f5f5f5;
    border-color: #ccc;
}

.MindmapEditor_task_item--checked {
    opacity: 0.6;
}

.MindmapEditor_task_item--checked .MindmapEditor_task_item_title {
    text-decoration: line-through;
}

.MindmapEditor_task_item_checkbox {
    width: 14px;
    height: 14px;
    border: 2px solid #999;
    border-radius: 3px;
    flex-shrink: 0;
}

.MindmapEditor_task_item_checkbox--checked {
    background: #4caf50;
    border-color: #4caf50;
    position: relative;
}

.MindmapEditor_task_item_checkbox--checked::after {
    content: '';
    position: absolute;
    left: 3px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.MindmapEditor_task_item_title {
    font-size: 12px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Notes on canvas (different from stickers) */
.MindmapEditor_object--note {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border: none;
    border-radius: 2px;
    box-shadow: 2px 3px 8px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1);
    min-height: 80px;
}

.MindmapEditor_object--note::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 14px;
    height: 14px;
    background: radial-gradient(circle at 30% 30%, #64b5f6, #1976d2);
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 -1px 2px rgba(0,0,0,0.2);
    z-index: 10;
}

.MindmapEditor_object--note::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.1) 100%);
    border-radius: 0 0 2px 0;
}

.MindmapEditor_object--note .MindmapEditor_object_text {
    padding-top: 28px;
    padding-bottom: 8px;
}

.MindmapEditor_object--note .MindmapEditor_object_marker_lt,
.MindmapEditor_object--note .MindmapEditor_object_marker_rt,
.MindmapEditor_object--note .MindmapEditor_object_marker_lb,
.MindmapEditor_object--note .MindmapEditor_object_marker_rb,
.MindmapEditor_object--note .MindmapEditor_object_marker_rotate {
    display: none;
}

/* Tasks on canvas */
.MindmapEditor_object--task {
    background: #fff !important;
    border-color: #ff9800 !important;
}

.MindmapEditor_object--task-checked {
    opacity: 0.6;
}

.MindmapEditor_object--task-checked .MindmapEditor_object_text {
    text-decoration: line-through;
    color: #999;
}

.MindmapEditor_object--task .MindmapEditor_object_content {
    flex-direction: row;
    gap: 8px;
    padding-left: 8px;
}

/* Task checkbox on canvas */
.MindmapEditor_object_task_checkbox {
    width: 16px;
    height: 16px;
    min-width: 16px;
    border: 2px solid #ff9800;
    border-radius: 3px;
    flex-shrink: 0;
    cursor: pointer;
    background: #fff;
}

.MindmapEditor_object_task_checkbox:hover {
    border-color: #f57c00;
    background: #fff3e0;
}

.MindmapEditor_object_task_checkbox--checked {
    background: #4caf50;
    border-color: #4caf50;
    position: relative;
}

.MindmapEditor_object_task_checkbox--checked:hover {
    background: #43a047;
    border-color: #43a047;
}

.MindmapEditor_object_task_checkbox--checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

/* Media tool button */
.MindmapEditor_tool--media {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    cursor: pointer;
}

.MindmapEditor_tool--media:hover {
    border-color: #f90;
    background: #fffaf5;
}

.MindmapEditor_tool_media_icon {
    font-size: 18px;
    color: #666;
}

/* Media content on canvas */
.MindmapEditor_media_content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 8px;
    background: #f5f5f5;
}

.MindmapEditor_media_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    pointer-events: none;
}

.MindmapEditor_media_video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
    background: #000;
}

.MindmapEditor_media_audio {
    width: 100%;
    height: 40px;
}

.MindmapEditor_audio_wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MindmapEditor_audio_drag_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: grab;
    z-index: 10;
}

.MindmapEditor_audio_drag_overlay:active {
    cursor: grabbing;
}

.MindmapEditor_video_wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.MindmapEditor_video_drag_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: grab;
    z-index: 10;
}

.MindmapEditor_video_drag_overlay:active {
    cursor: grabbing;
}

.MindmapEditor_object--media {
    background: transparent;
    border: none;
    overflow: visible;
}

/* Media upload modal */
.MindmapEditor_media_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.MindmapEditor_media_modal {
    background: white;
    border-radius: 12px;
    width: 420px;
    max-width: 90vw;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}

.MindmapEditor_media_modal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e4e4e9;
}

.MindmapEditor_media_modal_header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.MindmapEditor_media_modal_close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    line-height: 1;
}

.MindmapEditor_media_modal_close:hover {
    color: #333;
}

.MindmapEditor_media_modal_content {
    padding: 20px;
}

.MindmapEditor_media_modal_section {
    margin-bottom: 16px;
}

.MindmapEditor_media_modal_section label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
}

.MindmapEditor_media_modal_url_row {
    display: flex;
    gap: 8px;
}

.MindmapEditor_media_modal_url_row input {
    flex: 1;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
}

.MindmapEditor_media_modal_url_row input:focus {
    outline: none;
    border-color: #f90;
}

.MindmapEditor_media_modal_url_row button {
    padding: 10px 20px;
    background: #f90;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}

.MindmapEditor_media_modal_url_row button:hover {
    background: #e88a00;
}

.MindmapEditor_media_modal_divider {
    display: flex;
    align-items: center;
    margin: 20px 0;
}

.MindmapEditor_media_modal_divider::before,
.MindmapEditor_media_modal_divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e4e4e9;
}

.MindmapEditor_media_modal_divider span {
    padding: 0 12px;
    color: #999;
    font-size: 13px;
}

.MindmapEditor_media_modal_section input[type="file"] {
    width: 100%;
    padding: 12px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    cursor: pointer;
}

.MindmapEditor_media_modal_section input[type="file"]:hover {
    border-color: #f90;
}

.MindmapEditor_media_modal_progress {
    margin-top: 12px;
    position: relative;
    height: 24px;
    background: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
}

.MindmapEditor_media_modal_progress_bar {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #f90;
    transition: width 0.2s ease;
}

.MindmapEditor_media_modal_progress span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    font-weight: 500;
    color: #333;
}

/* Drawing tool styles */
.MindmapEditor_tool--draw {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    cursor: pointer;
    color: #666;
}

.MindmapEditor_tool--draw:hover {
    border-color: #f90;
    background: #fffaf5;
}

.MindmapEditor_tool--draw.MindmapEditor_tool--active {
    background: #f90;
    border-color: #f90;
    color: #fff;
}

.MindmapEditor_drawing_options {
    padding: 8px;
    border-top: 1px solid #e4e4e9;
    margin-top: 8px;
}

.MindmapEditor_drawing_option_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.MindmapEditor_drawing_option_row:last-child {
    margin-bottom: 0;
}

.MindmapEditor_drawing_option_label {
    font-size: 11px;
    color: #666;
}

.MindmapEditor_drawing_color_input {
    width: 28px;
    height: 24px;
    padding: 0;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    cursor: pointer;
    background: transparent;
}

.MindmapEditor_drawing_color_input::-webkit-color-swatch-wrapper {
    padding: 2px;
}

.MindmapEditor_drawing_color_input::-webkit-color-swatch {
    border: none;
    border-radius: 2px;
}

.MindmapEditor_drawing_width_options {
    display: flex;
    gap: 4px;
}

.MindmapEditor_drawing_width_btn {
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e4e4e9;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
}

.MindmapEditor_drawing_width_btn:hover {
    border-color: #f90;
}

.MindmapEditor_drawing_width_btn.active {
    border-color: #f90;
    background: #fffaf5;
}

.MindmapEditor_drawings_layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: visible;
    z-index: 4;
}

.MindmapEditor_drawing_selection_box {
    z-index: 6;
    pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/MindmapEditor.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;;IAEhB,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;;IAEhC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;AAChB;;;AAGA;IACI,OAAO;IACP,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,6DAA6D;IAC7D,kBAAkB;IAClB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,wBAAwB;IACxB,6DAA6D;IAC7D,kBAAkB;IAClB,uDAAuD;IACvD,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0DAA0D;IAC1D,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,iDAAiD;IACjD,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iFAAiF;IACjF,eAAe;IACf,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iFAAiF;AACrF;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;;IAEhB,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,oEAAoE;IACpE,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,YAAY;GACb,+BAA+B;AAClC;;;AAGA;;AAEA;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,mEAAmE;IACnE,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,gEAAgE;IAChE,kBAAkB;IAClB,uEAAuE;IACvE,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gGAAgG;IAChG,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;;IAKI,aAAa;AACjB;;AAEA;;IAEI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;AACjB;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAA8C;IAC9C,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,yDAAoD;AACxD;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,sDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,sDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,0GAA0G;IAC1G,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,0GAA0G;IAC1G,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,gEAAgE;IAChE,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,0EAA0E;AAC9E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kCAAkC;IAClC,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,2DAAwS;AAC5S;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;IAII,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gCAAgC;IAChC,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,6DAA6D;IAC7D,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA,0CAA0C;AAC1C;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,mEAAmE;IACnE,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,gEAAgE;IAChE,kBAAkB;IAClB,uEAAuE;IACvE,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gGAAgG;IAChG,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;;IAKI,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".MindmapEditor{\n    height: 100%;\n    padding: 10px;\n    background: #f9f9f6;\n}\n\n.MindmapEditor--fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n    padding: 0;\n    background: #f9f9f6;\n}\n\n.MindmapEditor--fullscreen .MindmapEditor_wrapper {\n    border-radius: 0;\n    border: none;\n}\n\n.MindmapEditor--fullscreen .MindmapEditor_zoom_controls {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n}\n\n.MindmapEditor_wrapper{\n    background: #FFFFFF;\n    border: 1px solid #E2E9FC;\n    border-radius: 24px;\n    overflow: hidden;\n\n    display: flex;\n    height: 100%;\n    min-height: 400px;\n}\n\n.MindmapEditor_tools{\n    border-right: 1px solid #E2E9FC;\n    width: 200px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.MindmapEditor_tools_header{\n    padding: 18px 23px;\n    border-bottom: 1px solid #E2E9FC;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.MindmapEditor_tools_header_title{\n    display: flex;\n    justify-content: flex-start;\n    flex-grow: 1;\n}\n\n\n.MindmapEditor_tools_categories{\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.MindmapEditor_tools_categories::-webkit-scrollbar{\n    display: none;\n}\n\n.MindmapEditor_settings{\n    border-top: 1px solid #E2E9FC;\n    padding: 12px 16px;\n    flex-shrink: 0;\n}\n\n.MindmapEditor_settings_title{\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #333;\n}\n\n.MindmapEditor_settings_row{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n}\n\n.MindmapEditor_settings_label{\n    font-size: 12px;\n    color: #666;\n}\n\n.MindmapEditor_bg_switcher {\n    position: relative;\n    display: flex;\n    background: linear-gradient(135deg, #f5f5f5 0%, #eaeaea 100%);\n    border-radius: 6px;\n    padding: 2px;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.MindmapEditor_bg_switcher_slider {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: calc(50% - 2px);\n    height: calc(100% - 4px);\n    background: linear-gradient(135deg, #ff9500 0%, #ff7b00 100%);\n    border-radius: 4px;\n    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    box-shadow: 0 1px 3px rgba(255, 149, 0, 0.3);\n    z-index: 0;\n}\n\n.MindmapEditor_bg_switcher_btn {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 500;\n    border: none;\n    border-radius: 4px;\n    background: transparent;\n    color: #666;\n    cursor: pointer;\n    transition: color 0.2s ease;\n    z-index: 1;\n    position: relative;\n}\n\n.MindmapEditor_bg_switcher_btn.active {\n    color: #fff;\n}\n\n.MindmapEditor_color_picker_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);\n    border-radius: 10px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n    max-height: 0;\n    opacity: 0;\n    overflow: hidden;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    padding: 0 12px;\n    margin-bottom: 0;\n}\n\n.MindmapEditor_color_picker_wrapper.visible {\n    max-height: 60px;\n    opacity: 1;\n    padding: 10px 12px;\n    margin-bottom: 12px;\n}\n\n.MindmapEditor_settings_color_enhanced {\n    width: 0;\n    height: 0;\n    opacity: 0;\n    position: absolute;\n}\n\n.MindmapEditor_color_preview {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3);\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    position: relative;\n}\n\n.MindmapEditor_color_preview:hover {\n    transform: scale(1.08);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.MindmapEditor_color_preview:active {\n    transform: scale(0.95);\n}\n\n.MindmapEditor_color_hex {\n    font-size: 11px;\n    font-weight: 600;\n    color: #888;\n    font-family: 'Monaco', 'Menlo', monospace;\n    letter-spacing: 0.5px;\n}\n\n.MindmapEditor_color_label {\n    display: block;\n    position: relative;\n    cursor: pointer;\n}\n\n.MindmapEditor_settings_bg_selector {\n    display: flex;\n    gap: 4px;\n}\n\n.MindmapEditor_settings_bg_btn {\n    padding: 4px 8px;\n    font-size: 11px;\n    border: 1px solid #E2E9FC;\n    border-radius: 4px;\n    background: #fff;\n    cursor: pointer;\n    color: #666;\n    transition: all 0.15s ease;\n}\n\n.MindmapEditor_settings_bg_btn:hover {\n    background: #f5f5f5;\n}\n\n.MindmapEditor_settings_bg_btn.active {\n    background: #f90;\n    border-color: #f90;\n    color: #fff;\n}\n\n.MindmapEditor_settings_color{\n    width: 32px;\n    height: 24px;\n    border: 1px solid #E2E9FC;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 0;\n    background: transparent;\n}\n\n.MindmapEditor_settings_color::-webkit-color-swatch-wrapper{\n    padding: 2px;\n}\n\n.MindmapEditor_settings_color::-webkit-color-swatch{\n    border: none;\n    border-radius: 2px;\n}\n\n.MindmapEditor_settings_toggle{\n    position: relative;\n    width: 36px;\n    height: 20px;\n    cursor: pointer;\n}\n\n.MindmapEditor_settings_toggle input{\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.MindmapEditor_settings_toggle_slider{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    border-radius: 20px;\n    transition: 0.3s;\n}\n\n.MindmapEditor_settings_toggle_slider::before{\n    content: '';\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    left: 2px;\n    bottom: 2px;\n    background-color: white;\n    border-radius: 50%;\n    transition: 0.3s;\n}\n\n.MindmapEditor_settings_toggle input:checked + .MindmapEditor_settings_toggle_slider{\n    background-color: #f90;\n}\n\n.MindmapEditor_settings_toggle input:checked + .MindmapEditor_settings_toggle_slider::before{\n    transform: translateX(16px);\n}\n\n.MindmapEditor_right{\n    width: 100%;\n}\n\n.MindmapEditor_right_header{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 1px solid #E2E9FC;\n    padding: 8px;\n}\n\n.MindmapEditor_right_header_title{\n    display: flex;\n    justify-content: center;\n    flex-grow: 1;\n}\n\n.MindmapEditor_workspace{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    user-select: none;\n    overflow: hidden;\n\n    background-size: 10px 10px;\n    background-position: -5px -5px;\n    background-color: #fff5ec;\n    background-image: radial-gradient(#999 0%, #999 9%, transparent 12%);\n    outline: none;\n}\n\n.MindmapEditor_object{\n    position: absolute;\n    background-color: #fc0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #f90;\n    z-index: 5;\n    cursor: grab;\n   /* transform-origin: left top;*/\n}\n\n\n.MindmapEditor_object--box{\n\n}\n\n.MindmapEditor_object--round{\n    border-radius: 100%;\n}\n\n.MindmapEditor_object--triangle,\n.MindmapEditor_object--trapezoid,\n.MindmapEditor_object--star {\n    border: none;\n    background: transparent;\n}\n\n.MindmapEditor_object_svg {\n    pointer-events: none;\n}\n\n.MindmapEditor_object--sticker{\n    background: linear-gradient(135deg, #fffacd 0%, #fff59d 100%);\n    border: none;\n    border-radius: 2px;\n    box-shadow: 2px 3px 8px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1);\n    min-height: 80px;\n}\n\n.MindmapEditor_object--sticker::before{\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 14px;\n    height: 14px;\n    background: radial-gradient(circle at 30% 30%, #ff6b6b, #c92a2a);\n    border-radius: 50%;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 -1px 2px rgba(0,0,0,0.2);\n    z-index: 10;\n}\n\n.MindmapEditor_object--sticker::after{\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.1) 100%);\n    border-radius: 0 0 2px 0;\n}\n\n.MindmapEditor_object--sticker .MindmapEditor_object_text{\n    padding-top: 28px;\n    padding-bottom: 8px;\n}\n\n.MindmapEditor_object--sticker .MindmapEditor_object_marker_lt,\n.MindmapEditor_object--sticker .MindmapEditor_object_marker_rt,\n.MindmapEditor_object--sticker .MindmapEditor_object_marker_lb,\n.MindmapEditor_object--sticker .MindmapEditor_object_marker_rb,\n.MindmapEditor_object--sticker .MindmapEditor_object_marker_rotate{\n    display: none;\n}\n\n.MindmapEditor_object--sticker.MindmapEditor_object--selected,\n.MindmapEditor_object--sticker.MindmapEditor_object--multi-selected{\n    outline: 2px solid #0af;\n    outline-offset: 0px;\n}\n\n.MindmapEditor_object--text{\n    background: transparent;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.MindmapEditor_object--text .MindmapEditor_object_text{\n    font-size: 16px;\n    color: #333;\n    text-align: center;\n    padding: 4px 8px;\n}\n\n.MindmapEditor_object--text.MindmapEditor_object--selected,\n.MindmapEditor_object--text.MindmapEditor_object--multi-selected{\n    outline: 1px dashed #0af;\n    outline-offset: 2px;\n}\n\n.MindmapEditor_toolsCollapser_head{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 10px;\n}\n\n.MindmapEditor_toolsCollapser_head_title{\n\n}\n\n.MindmapEditor_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n    margin-left: auto;\n    margin-right: 8px;\n}\n\n.MindmapEditor_filter_icon:hover {\n    opacity: 1;\n}\n\n.MindmapEditor_filter_icon--active {\n    background-image: url('../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.MindmapEditor_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.MindmapEditor_toolsCollapser_head_arrow{\n    flex-shrink: 0;\n    font-size: 0;\n    width: 9px;\n    height: 9px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-image: url(\"../../assets/open-arrow.svg\");\n}\n\n.MindmapEditor_toolsCollapser_collapser{\n    padding: 0px 10px;\n    background-color: #f6f6f9;\n}\n\n.MindmapEditor_toolsCollapser_items{\n    padding: 10px 0px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.MindmapEditor_tool{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #f30;\n    flex-shrink: 0;\n    cursor: pointer;\n    user-select: none;\n    font-size: 10px;\n}\n\n.MindmapEditor_tool--box{\n    background-color: #fc0;\n    border: 1px solid #f90;\n    width: 42px;\n    height: 42px;\n}\n\n.MindmapEditor_tool--round{\n    background-color: #fc0;\n    border: 1px solid #f90;\n    width: 42px;\n    height: 42px;\n    border-radius: 100%;\n}\n\n.MindmapEditor_tool--triangle{\n    width: 42px;\n    height: 42px;\n    position: relative;\n}\n\n.MindmapEditor_tool--triangle::after{\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-color: #f90;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    z-index: 0;\n}\n\n.MindmapEditor_tool--triangle::before{\n    content: '';\n    position: absolute;\n    inset: 2px;\n    background-color: #fc0;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    z-index: 1;\n}\n\n.MindmapEditor_tool--trapezoid{\n    width: 42px;\n    height: 42px;\n    position: relative;\n}\n\n.MindmapEditor_tool--trapezoid::after{\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-color: #f90;\n    clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n    z-index: 0;\n}\n\n.MindmapEditor_tool--trapezoid::before{\n    content: '';\n    position: absolute;\n    inset: 2px;\n    background-color: #fc0;\n    clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n    z-index: 1;\n}\n\n.MindmapEditor_tool--star{\n    width: 42px;\n    height: 42px;\n    position: relative;\n}\n\n.MindmapEditor_tool--star::after{\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-color: #f90;\n    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n    z-index: 0;\n}\n\n.MindmapEditor_tool--star::before{\n    content: '';\n    position: absolute;\n    inset: 2px;\n    background-color: #fc0;\n    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n    z-index: 1;\n}\n\n.MindmapEditor_tool--sticker{\n    width: 36px;\n    height: 42px;\n    position: relative;\n    background: linear-gradient(135deg, #fffacd 0%, #fff59d 100%);\n    border-radius: 2px;\n    box-shadow: 1px 2px 4px rgba(0,0,0,0.15);\n}\n\n.MindmapEditor_tool--sticker::before{\n    content: '';\n    position: absolute;\n    top: 4px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 8px;\n    height: 8px;\n    background: radial-gradient(circle at 30% 30%, #ff6b6b, #c92a2a);\n    border-radius: 50%;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.3);\n    z-index: 1;\n}\n\n.MindmapEditor_tool--sticker::after{\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 10px;\n    height: 10px;\n    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.08) 50%);\n}\n\n.MindmapEditor_tool--text{\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.MindmapEditor_tool--text:hover{\n    border-color: #f90;\n    background: #fffaf5;\n}\n\n.MindmapEditor_tool_text_preview{\n    font-size: 16px;\n    font-weight: 500;\n    color: #666;\n}\n\n.MindmapEditor_object--selected{\n    box-shadow: 0 0 0 2px #0af;\n}\n\n.MindmapEditor_object--multi-selected{\n    box-shadow: 0 0 0 2px #0af;\n}\n\n.MindmapEditor_selection_box {\n    position: absolute;\n    border: 1px dashed #0af;\n    background: rgba(0, 170, 255, 0.1);\n    pointer-events: none;\n    z-index: 1000;\n}\n\n.MindmapEditor_style_popup {\n    position: absolute;\n    transform: translateX(-50%);\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 12px rgba(0,0,0,0.15);\n    padding: 8px 12px;\n    z-index: 1001;\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n\n.MindmapEditor_style_popup_section {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.MindmapEditor_style_popup_label {\n    font-size: 12px;\n    color: #666;\n    white-space: nowrap;\n}\n\n.MindmapEditor_style_popup_colors {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.MindmapEditor_style_popup_color {\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: transform 0.1s, border-color 0.1s;\n}\n\n.MindmapEditor_style_popup_color:hover {\n    transform: scale(1.1);\n}\n\n.MindmapEditor_style_popup_color--active {\n    border-color: #333;\n}\n\n.MindmapEditor_style_popup_picker {\n    width: 24px;\n    height: 24px;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    background: none;\n    border-radius: 4px;\n}\n\n.MindmapEditor_style_popup_picker::-webkit-color-swatch-wrapper {\n    padding: 0;\n}\n\n.MindmapEditor_style_popup_picker::-webkit-color-swatch {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.MindmapEditor_style_popup_border {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.MindmapEditor_style_popup_select {\n    padding: 4px 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 12px;\n    background: white;\n    cursor: pointer;\n}\n\n.MindmapEditor_object_markers{\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n}\n\n.MindmapEditor_object_marker{\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    pointer-events: all;\n\n    background-color: #999;\n}\n\n.MindmapEditor_object_marker_lt{\n    right: 100%;\n    bottom: 100%;\n    cursor: nwse-resize;\n}\n.MindmapEditor_object_marker_lb{\n    right: 100%;\n    top: 100%;\n    cursor: nesw-resize;\n}\n.MindmapEditor_object_marker_rt{\n    left: 100%;\n    bottom: 100%;\n    cursor: nesw-resize;\n}\n.MindmapEditor_object_marker_rb{\n    left: 100%;\n    top: 100%;\n    cursor: nwse-resize;\n}\n.MindmapEditor_object_marker_rotate{\n    border-radius: 100%;\n    left: calc(50% - 5px);\n    bottom: 100%;\n    cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38'/%3E%3C/svg%3E\") 12 12, grab;\n}\n\n.MindmapEditor_object_content {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.MindmapEditor_object_content--star {\n    padding: 18% 12%;\n}\n\n.MindmapEditor_object_text {\n    width: 100%;\n    max-height: 100%;\n    border: none;\n    background: transparent;\n    text-align: center;\n    font-size: 12px;\n    padding: 4px;\n    position: relative;\n    z-index: 2;\n    outline: none;\n    cursor: text;\n    overflow: hidden;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    direction: ltr;\n    unicode-bidi: plaintext;\n}\n\n.MindmapEditor_object_text:empty {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.MindmapEditor_object_text:empty::before {\n    content: '...';\n    color: rgba(0, 0, 0, 0.4);\n    pointer-events: none;\n}\n\n.MindmapEditor_object_text--dragging {\n    cursor: grabbing;\n    pointer-events: none;\n    user-select: none;\n}\n\n.MindmapEditor_object_text--inactive {\n    pointer-events: none;\n    cursor: grab;\n}\n\n.MindmapEditor_object_text[data-placeholder]:empty::before {\n    content: attr(data-placeholder);\n    color: #aaa;\n    font-style: italic;\n    pointer-events: none;\n}\n\n.MindmapEditor_object:active {\n    cursor: grabbing;\n}\n\n.MindmapEditor_right_header_title_input {\n    flex-grow: 1;\n    text-align: center;\n    border: none;\n    outline: none;\n    font-size: 16px;\n    font-weight: 500;\n    background: transparent;\n}\n\n.MindmapEditor_saving {\n    color: #999;\n    font-size: 12px;\n    margin-right: 8px;\n}\n\n.MindmapEditor_tools_actions {\n    padding: 10px;\n    border-top: 1px solid #E2E9FC;\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.MindmapEditor_export_btn {\n    width: 100%;\n    padding: 8px 16px;\n    background: #4a90d9;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.MindmapEditor_export_btn:hover {\n    background: #3a7bc8;\n}\n\n.MindmapEditor_delete_btn {\n    width: 100%;\n    padding: 8px 16px;\n    background: #ff4444;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.MindmapEditor_delete_btn:hover {\n    background: #cc0000;\n}\n\n.MindmapEditor_contextMenu {\n    position: fixed;\n    background: white;\n    border: 1px solid #E2E9FC;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n    z-index: 1010;\n    min-width: 120px;\n    padding: 4px 0;\n}\n\n.MindmapEditor_contextMenu_item {\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n}\n\n.MindmapEditor_contextMenu_item:hover {\n    background: #f5f5f5;\n}\n\n.MindmapEditor_manual_hint {\n    position: absolute;\n    bottom: 12px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid #e4e4e9;\n    border-radius: 6px;\n    padding: 6px 12px;\n    font-size: 11px;\n    color: #666;\n    text-align: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n    pointer-events: none;\n}\n\n.MindmapEditor_manual_hint div {\n    white-space: nowrap;\n}\n\n.MindmapEditor_manual_hint div + div {\n    margin-top: 2px;\n}\n\n.MindmapEditor_tool--arrow-thin,\n.MindmapEditor_tool--arrow-thick,\n.MindmapEditor_tool--arrow-hollow,\n.MindmapEditor_tool--arrow-block {\n    width: 42px;\n    height: 42px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.MindmapEditor_tool--arrow-thin:hover,\n.MindmapEditor_tool--arrow-thick:hover,\n.MindmapEditor_tool--arrow-hollow:hover,\n.MindmapEditor_tool--arrow-block:hover {\n    border-color: #f90;\n}\n\n.MindmapEditor_tool--active {\n    border-color: #f90;\n    background: #fff5e6;\n    box-shadow: 0 0 0 2px rgba(255, 153, 0, 0.3);\n}\n\n.MindmapEditor_arrow_hint {\n    padding: 8px 10px;\n    font-size: 11px;\n    color: #666;\n    background: #fff5e6;\n    border-radius: 4px;\n    margin-bottom: 10px;\n}\n\n.MindmapEditor_arrows_section_label {\n    font-size: 11px;\n    color: #888;\n    padding: 4px 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.MindmapEditor_arrows_section_divider {\n    height: 1px;\n    background: #e4e4e9;\n    margin: 8px 0;\n}\n\n.MindmapEditor_arrows_layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 1;\n    overflow: visible;\n}\n\n.MindmapEditor_arrow {\n    pointer-events: stroke;\n    cursor: pointer;\n}\n\n.MindmapEditor_arrow:hover path {\n    stroke: #ff6600;\n}\n\n.MindmapEditor_snap_points {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n}\n\n.MindmapEditor_snap_point {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    background: #fff;\n    border: 2px solid #f90;\n    border-radius: 50%;\n    pointer-events: auto;\n    cursor: crosshair;\n    z-index: 10;\n    transition: transform 0.1s, background 0.1s;\n}\n\n.MindmapEditor_snap_point:hover {\n    transform: scale(1.3);\n    background: #f90;\n}\n\n.MindmapEditor_snap_point--active {\n    background: #f90;\n    transform: scale(1.3);\n}\n\n.MindmapEditor_snap_point--dim {\n    opacity: 0.5;\n    transform: scale(0.8);\n}\n\n.MindmapEditor_snap_point--dim:hover {\n    opacity: 1;\n    transform: scale(1.3);\n}\n\n.MindmapEditor_snap_point--editing {\n    border-color: #0af;\n}\n\n.MindmapEditor_snap_point--editing:hover {\n    background: #0af;\n}\n\n.MindmapEditor_arrow_endpoint {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    background: #0af;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    cursor: pointer;\n    z-index: 15;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n    transition: transform 0.1s;\n}\n\n.MindmapEditor_arrow_endpoint:hover {\n    transform: translate(-50%, -50%) scale(1.2);\n}\n\n.MindmapEditor_arrow_endpoint--start {\n    background: #0af;\n}\n\n.MindmapEditor_arrow_endpoint--end {\n    background: #0af;\n}\n\n.MindmapEditor_segment_handle {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #f90;\n    border: 2px solid #fff;\n    border-radius: 2px;\n    cursor: move;\n    z-index: 14;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n    transition: transform 0.1s, background 0.1s;\n}\n\n.MindmapEditor_segment_handle:hover {\n    transform: translate(-50%, -50%) scale(1.2);\n    background: #0af;\n}\n\n.MindmapEditor_waypoint_handle {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #0af;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    cursor: move;\n    z-index: 15;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 1px 3px rgba(0,0,0,0.3);\n    transition: transform 0.1s, background 0.1s;\n}\n\n.MindmapEditor_waypoint_handle:hover {\n    transform: translate(-50%, -50%) scale(1.3);\n    background: #f90;\n}\n\n.MindmapEditor_canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: auto;\n}\n\n.MindmapEditor_camera {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n}\n\n.MindmapEditor_camera > * {\n    pointer-events: auto;\n}\n\n.MindmapEditor_zoom_controls {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(255, 255, 255, 0.95);\n    border: 1px solid #e4e4e9;\n    border-radius: 8px;\n    padding: 6px 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n}\n\n.MindmapEditor_zoom_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    color: #666;\n    transition: background 0.15s, color 0.15s;\n}\n\n.MindmapEditor_zoom_btn:hover {\n    background: #f0f0f0;\n    color: #333;\n}\n\n.MindmapEditor_zoom_btn svg {\n    color: #666;\n}\n\n.MindmapEditor_zoom_btn:hover svg {\n    color: #f90;\n}\n\n.MindmapEditor_zoom_indicator {\n    font-size: 12px;\n    font-weight: 500;\n    color: #333;\n    min-width: 40px;\n    text-align: center;\n}\n\n/* Folders section in toolbar */\n.MindmapEditor_folders_filter {\n    padding: 8px 12px;\n}\n\n.MindmapEditor_folders_filter_label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #666;\n    cursor: pointer;\n}\n\n.MindmapEditor_folders_filter_label input[type=\"checkbox\"] {\n    cursor: pointer;\n}\n\n.MindmapEditor_folders_list {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 4px 8px;\n}\n\n.MindmapEditor_folders_loading {\n    display: flex;\n    justify-content: center;\n    padding: 16px;\n}\n\n.MindmapEditor_folders_empty {\n    text-align: center;\n    padding: 16px;\n    font-size: 12px;\n    color: #999;\n}\n\n.MindmapEditor_folder_item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: 6px;\n    cursor: grab;\n    transition: background 0.15s;\n}\n\n.MindmapEditor_folder_item:hover {\n    background: #f5f5f5;\n}\n\n.MindmapEditor_folder_item_icon {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n}\n\n.MindmapEditor_folder_item_name {\n    font-size: 12px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Folder block on canvas */\n.MindmapEditor_object--folder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%);\n    border: 2px solid #ffa000;\n    border-radius: 8px;\n    cursor: pointer;\n    padding: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n.MindmapEditor_object--folder:hover {\n    box-shadow: 0 4px 12px rgba(255,160,0,0.3);\n    border-color: #ff8f00;\n}\n\n.MindmapEditor_object--folder .MindmapEditor_folder_block_icon {\n    width: 40px;\n    height: 40px;\n}\n\n.MindmapEditor_object--folder .MindmapEditor_folder_block_name {\n    font-size: 11px;\n    color: #333;\n    text-align: center;\n    word-break: break-word;\n    max-width: 100%;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n/* Hide resize markers for folder blocks */\n.MindmapEditor_object--folder .MindmapEditor_object_markers {\n    display: none;\n}\n\n.MindmapEditor_folder_block_content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n}\n\n.MindmapEditor_folders_breadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px;\n    border-bottom: 1px solid #eee;\n}\n\n.MindmapEditor_folders_back_btn {\n    background: none;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 4px 8px;\n    cursor: pointer;\n    font-size: 12px;\n    color: #666;\n}\n\n.MindmapEditor_folders_back_btn:hover {\n    background: #f5f5f5;\n    color: #333;\n}\n\n.MindmapEditor_folders_current_name {\n    font-size: 12px;\n    font-weight: 500;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.MindmapEditor_folder_item {\n    position: relative;\n}\n\n.MindmapEditor_folder_expand_btn {\n    position: absolute;\n    right: 4px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    color: #999;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n\n.MindmapEditor_folder_expand_btn:hover {\n    background: #f0f0f0;\n    color: #666;\n}\n\n/* Notes section */\n.MindmapEditor_notes_list {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 4px 8px;\n}\n\n.MindmapEditor_notes_loading {\n    display: flex;\n    justify-content: center;\n    padding: 16px;\n}\n\n.MindmapEditor_notes_empty {\n    text-align: center;\n    padding: 16px;\n    font-size: 12px;\n    color: #999;\n}\n\n.MindmapEditor_note_item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: 6px;\n    cursor: grab;\n    transition: background 0.15s;\n    background: #fffacd;\n    border: 1px solid #f0e68c;\n    margin-bottom: 4px;\n}\n\n.MindmapEditor_note_item:hover {\n    background: #fff8b4;\n    border-color: #daa520;\n}\n\n.MindmapEditor_note_item_title {\n    font-size: 12px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Tasks section */\n.MindmapEditor_tasks_filter {\n    padding: 8px;\n    border-bottom: 1px solid #eee;\n}\n\n.MindmapEditor_tasks_filter_label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #666;\n    cursor: pointer;\n}\n\n.MindmapEditor_tasks_list {\n    max-height: 200px;\n    overflow-y: auto;\n    padding: 4px 8px;\n}\n\n.MindmapEditor_tasks_loading {\n    display: flex;\n    justify-content: center;\n    padding: 16px;\n}\n\n.MindmapEditor_tasks_empty {\n    text-align: center;\n    padding: 16px;\n    font-size: 12px;\n    color: #999;\n}\n\n.MindmapEditor_task_item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    border-radius: 6px;\n    cursor: grab;\n    transition: background 0.15s;\n    background: #fff;\n    border: 1px solid #ddd;\n    margin-bottom: 4px;\n}\n\n.MindmapEditor_task_item:hover {\n    background: #f5f5f5;\n    border-color: #ccc;\n}\n\n.MindmapEditor_task_item--checked {\n    opacity: 0.6;\n}\n\n.MindmapEditor_task_item--checked .MindmapEditor_task_item_title {\n    text-decoration: line-through;\n}\n\n.MindmapEditor_task_item_checkbox {\n    width: 14px;\n    height: 14px;\n    border: 2px solid #999;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n\n.MindmapEditor_task_item_checkbox--checked {\n    background: #4caf50;\n    border-color: #4caf50;\n    position: relative;\n}\n\n.MindmapEditor_task_item_checkbox--checked::after {\n    content: '';\n    position: absolute;\n    left: 3px;\n    top: 0px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.MindmapEditor_task_item_title {\n    font-size: 12px;\n    color: #333;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* Notes on canvas (different from stickers) */\n.MindmapEditor_object--note {\n    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n    border: none;\n    border-radius: 2px;\n    box-shadow: 2px 3px 8px rgba(0,0,0,0.15), 0 1px 3px rgba(0,0,0,0.1);\n    min-height: 80px;\n}\n\n.MindmapEditor_object--note::before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 14px;\n    height: 14px;\n    background: radial-gradient(circle at 30% 30%, #64b5f6, #1976d2);\n    border-radius: 50%;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.3), inset 0 -1px 2px rgba(0,0,0,0.2);\n    z-index: 10;\n}\n\n.MindmapEditor_object--note::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    background: linear-gradient(135deg, transparent 50%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.1) 100%);\n    border-radius: 0 0 2px 0;\n}\n\n.MindmapEditor_object--note .MindmapEditor_object_text {\n    padding-top: 28px;\n    padding-bottom: 8px;\n}\n\n.MindmapEditor_object--note .MindmapEditor_object_marker_lt,\n.MindmapEditor_object--note .MindmapEditor_object_marker_rt,\n.MindmapEditor_object--note .MindmapEditor_object_marker_lb,\n.MindmapEditor_object--note .MindmapEditor_object_marker_rb,\n.MindmapEditor_object--note .MindmapEditor_object_marker_rotate {\n    display: none;\n}\n\n/* Tasks on canvas */\n.MindmapEditor_object--task {\n    background: #fff !important;\n    border-color: #ff9800 !important;\n}\n\n.MindmapEditor_object--task-checked {\n    opacity: 0.6;\n}\n\n.MindmapEditor_object--task-checked .MindmapEditor_object_text {\n    text-decoration: line-through;\n    color: #999;\n}\n\n.MindmapEditor_object--task .MindmapEditor_object_content {\n    flex-direction: row;\n    gap: 8px;\n    padding-left: 8px;\n}\n\n/* Task checkbox on canvas */\n.MindmapEditor_object_task_checkbox {\n    width: 16px;\n    height: 16px;\n    min-width: 16px;\n    border: 2px solid #ff9800;\n    border-radius: 3px;\n    flex-shrink: 0;\n    cursor: pointer;\n    background: #fff;\n}\n\n.MindmapEditor_object_task_checkbox:hover {\n    border-color: #f57c00;\n    background: #fff3e0;\n}\n\n.MindmapEditor_object_task_checkbox--checked {\n    background: #4caf50;\n    border-color: #4caf50;\n    position: relative;\n}\n\n.MindmapEditor_object_task_checkbox--checked:hover {\n    background: #43a047;\n    border-color: #43a047;\n}\n\n.MindmapEditor_object_task_checkbox--checked::after {\n    content: '';\n    position: absolute;\n    left: 4px;\n    top: 1px;\n    width: 5px;\n    height: 9px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n/* Media tool button */\n.MindmapEditor_tool--media {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.MindmapEditor_tool--media:hover {\n    border-color: #f90;\n    background: #fffaf5;\n}\n\n.MindmapEditor_tool_media_icon {\n    font-size: 18px;\n    color: #666;\n}\n\n/* Media content on canvas */\n.MindmapEditor_media_content {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    border-radius: 8px;\n    background: #f5f5f5;\n}\n\n.MindmapEditor_media_image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 8px;\n    pointer-events: none;\n}\n\n.MindmapEditor_media_video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 8px;\n    background: #000;\n}\n\n.MindmapEditor_media_audio {\n    width: 100%;\n    height: 40px;\n}\n\n.MindmapEditor_audio_wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.MindmapEditor_audio_drag_overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    cursor: grab;\n    z-index: 10;\n}\n\n.MindmapEditor_audio_drag_overlay:active {\n    cursor: grabbing;\n}\n\n.MindmapEditor_video_wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.MindmapEditor_video_drag_overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    cursor: grab;\n    z-index: 10;\n}\n\n.MindmapEditor_video_drag_overlay:active {\n    cursor: grabbing;\n}\n\n.MindmapEditor_object--media {\n    background: transparent;\n    border: none;\n    overflow: visible;\n}\n\n/* Media upload modal */\n.MindmapEditor_media_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.MindmapEditor_media_modal {\n    background: white;\n    border-radius: 12px;\n    width: 420px;\n    max-width: 90vw;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);\n}\n\n.MindmapEditor_media_modal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e4e4e9;\n}\n\n.MindmapEditor_media_modal_header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.MindmapEditor_media_modal_close {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #999;\n    padding: 0;\n    line-height: 1;\n}\n\n.MindmapEditor_media_modal_close:hover {\n    color: #333;\n}\n\n.MindmapEditor_media_modal_content {\n    padding: 20px;\n}\n\n.MindmapEditor_media_modal_section {\n    margin-bottom: 16px;\n}\n\n.MindmapEditor_media_modal_section label {\n    display: block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.MindmapEditor_media_modal_url_row {\n    display: flex;\n    gap: 8px;\n}\n\n.MindmapEditor_media_modal_url_row input {\n    flex: 1;\n    padding: 10px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.MindmapEditor_media_modal_url_row input:focus {\n    outline: none;\n    border-color: #f90;\n}\n\n.MindmapEditor_media_modal_url_row button {\n    padding: 10px 20px;\n    background: #f90;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.MindmapEditor_media_modal_url_row button:hover {\n    background: #e88a00;\n}\n\n.MindmapEditor_media_modal_divider {\n    display: flex;\n    align-items: center;\n    margin: 20px 0;\n}\n\n.MindmapEditor_media_modal_divider::before,\n.MindmapEditor_media_modal_divider::after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background: #e4e4e9;\n}\n\n.MindmapEditor_media_modal_divider span {\n    padding: 0 12px;\n    color: #999;\n    font-size: 13px;\n}\n\n.MindmapEditor_media_modal_section input[type=\"file\"] {\n    width: 100%;\n    padding: 12px;\n    border: 2px dashed #ddd;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.MindmapEditor_media_modal_section input[type=\"file\"]:hover {\n    border-color: #f90;\n}\n\n.MindmapEditor_media_modal_progress {\n    margin-top: 12px;\n    position: relative;\n    height: 24px;\n    background: #f0f0f0;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.MindmapEditor_media_modal_progress_bar {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    background: #f90;\n    transition: width 0.2s ease;\n}\n\n.MindmapEditor_media_modal_progress span {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 12px;\n    font-weight: 500;\n    color: #333;\n}\n\n/* Drawing tool styles */\n.MindmapEditor_tool--draw {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #fff;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    cursor: pointer;\n    color: #666;\n}\n\n.MindmapEditor_tool--draw:hover {\n    border-color: #f90;\n    background: #fffaf5;\n}\n\n.MindmapEditor_tool--draw.MindmapEditor_tool--active {\n    background: #f90;\n    border-color: #f90;\n    color: #fff;\n}\n\n.MindmapEditor_drawing_options {\n    padding: 8px;\n    border-top: 1px solid #e4e4e9;\n    margin-top: 8px;\n}\n\n.MindmapEditor_drawing_option_row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.MindmapEditor_drawing_option_row:last-child {\n    margin-bottom: 0;\n}\n\n.MindmapEditor_drawing_option_label {\n    font-size: 11px;\n    color: #666;\n}\n\n.MindmapEditor_drawing_color_input {\n    width: 28px;\n    height: 24px;\n    padding: 0;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    cursor: pointer;\n    background: transparent;\n}\n\n.MindmapEditor_drawing_color_input::-webkit-color-swatch-wrapper {\n    padding: 2px;\n}\n\n.MindmapEditor_drawing_color_input::-webkit-color-swatch {\n    border: none;\n    border-radius: 2px;\n}\n\n.MindmapEditor_drawing_width_options {\n    display: flex;\n    gap: 4px;\n}\n\n.MindmapEditor_drawing_width_btn {\n    width: 28px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #e4e4e9;\n    border-radius: 4px;\n    background: #fff;\n    cursor: pointer;\n}\n\n.MindmapEditor_drawing_width_btn:hover {\n    border-color: #f90;\n}\n\n.MindmapEditor_drawing_width_btn.active {\n    border-color: #f90;\n    background: #fffaf5;\n}\n\n.MindmapEditor_drawings_layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    overflow: visible;\n    z-index: 4;\n}\n\n.MindmapEditor_drawing_selection_box {\n    z-index: 6;\n    pointer-events: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
